module.exports = __webpack_public_path__ + "officialStatic/img/news22.0ec9253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news22.jpg
// module id = PQVM
// module chunks = 0